import React, { useEffect, useState, useMemo } from 'react'
import styled from 'styled-components' 
import { useDispatch, useSelector } from 'react-redux';
import { createCampaignGivingIntentMembers, resetCampaignPayment, createCampaignGivingIntentPublic, resetCampaignIntent, setFormData } from 'features/givingCampaigns/givingCampaignSlice'; 
import {Elements } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js'; 
import { pkStripe } from 'features/constants';
import { RiSecurePaymentFill } from "react-icons/ri";
import ConfirmGivingPayment from './ConfirmGivingPayment'
import { useParams } from 'react-router-dom'
import { DH1, DonateContainer } from '../giving.styled';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { InputIconWrap } from '../giving.styled'; 
import { PiArrowBendDownLeft } from "react-icons/pi";
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import SpinnerSmall from 'components/SpinnerSmall'; 
import { TbHeartCheck } from "react-icons/tb";
import { pBtn } from 'components/main.styled';
import { MdVisibilityOff } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { useTranslation } from 'react-i18next'
import { useLocalizedFormatters } from 'i18n/useLocalizedFormatters'


export default function Donate() {
    const { t } = useTranslation('giving')
    const { formatCurrency } = useLocalizedFormatters()

    const dispatch = useDispatch()  
    const params = useParams()

    const { user } = useSelector(state => state.auth) 
    const { 
        church,
        amount,
        clientSecret, 
        singleCampaignData, 
        createPaymentIntentSuccess,
        createPaymentIntentLoading,
        updateCampaignTotalsSuccess
    } = useSelector((state) => state.givingCampaign) 

    const [donationAmount, setDonationAmount] = useState(50)
    const [useCustomAmount, setUseCustomAmount] = useState(false)
    const [anonymous, setAnonymous] = useState(false)
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')

    const [errorField, setErrorField] = useState({
        amount: false,
        email: false,
        name: false
    })

    const handleDonationAmount = (e, value) => { 
        if(errorField.amount){
            setErrorField({
                ...errorField,
                amount: false
            })
        }    
        setDonationAmount(value)
        dispatch(setFormData({
            key: 'amount',
            value: value
        }))
    }

    const handleConfirmAmount = () => {    
        if(!user){
            if(!amount || (!name && !anonymous) || (!email && !user)){ 
                setErrorField({
                    ...errorField,
                    amount: !amount ? true : false,
                    name: (!name && !anonymous) ? true : false,
                    email: (!email && !user) ? true : false
                }) 
                return
            }

            dispatch(createCampaignGivingIntentPublic({
                amount: amount,
                description: singleCampaignData.title,
                campaignId: params.campaignId,
                email: email,
                name: name,
                anonymous: anonymous
            }))  
        }else{ 
            if(amount < 1){
                setErrorField({
                    ...errorField,
                    amount: amount < 1 ? true : false
                })
                return
            } 
            dispatch(createCampaignGivingIntentMembers({ 
                amount: amount,
                description: singleCampaignData.title,
                campaignId: params.campaignId,
                anonymous: anonymous
            }))
        }  
    } 
 
    const stripePromise = useMemo(
        () => loadStripe( pkStripe, { stripeAccount: church.stripeId, } ), 
        [ church.stripeId ]
    )

    const handleRestartDonation = () => {
        dispatch(setFormData({  
            key: amount,
            value: 0
        }))
        setDonationAmount(50)
        setUseCustomAmount(false)
        setAnonymous(false)
        setEmail('')
        setName('')
        setErrorField({
            amount: false,
            email: false,
            name: false
        })
        dispatch(resetCampaignIntent())
    }

    const reset2 = () => {
        handleRestartDonation()
        dispatch(resetCampaignPayment())
    }

    useEffect(() => {
        //  on unmount reset payment intent data
        return () => {
            dispatch(resetCampaignIntent())
        }
    } , [])

    return (
        <DonateContainer maxHeight={'800px'} > 
            {!updateCampaignTotalsSuccess && <DH1>{t('campaigns.donateTab')}</DH1>}

            { 
                !createPaymentIntentSuccess && !updateCampaignTotalsSuccess ?
                (
                    <PrePaymentIntentContainer> 
                        {
                            user && 
                            (
                                <div>
                                    {/* 
                                        here if a logged in user is present we can 
                                        display saved payment methods
                                    */}
                                </div>
                            )   
                        }
   {
                            !user ? 
                            (
                                <div style={{ width: '100%'  }} > 
                                    {
                                        !anonymous &&
                                        (
                                            <InputWrap> 
                                                <InputIconWrap2 isError={errorField.name && !anonymous} >
                                                    <input 
                                                        type="text" 
                                                        placeholder={t('campaigns.donation.namePlaceholder')}
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        />
                                                </InputIconWrap2>
                                            </InputWrap>
                                        )
                                    }

                                    <InputWrap> 
                                        <InputIconWrap2 isError={errorField.email && !user} >
                                            <input 
                                                type="email" 
                                                placeholder={t('campaigns.donation.emailPlaceholder')}
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                />
                                        </InputIconWrap2>
                                    </InputWrap>
                                    <ABtnW>
                                        <AnCnt style={{  visibility: anonymous ? 'visible' : 'hidden' }} > 
                                            <NoAccountsIcon /> {t('form.anonymousName')}
                                        </AnCnt>
                                        
                                        <ABtn onClick={() => setAnonymous(!anonymous)} > 
                                            {
                                                anonymous ?
                                                (
                                                    t('campaigns.donation.displayName')
                                                )
                                                :
                                                (
                                                    t('form.anonymousName')
                                                )
                                            }
                                        </ABtn>                            
                                    </ABtnW> 
                                </div>
                            )
                            :
                            (
                                <div style={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                    <UserInfo>
                                        {
                                            anonymous ? 
                                            (
                                                <AnCnt><NoAccountsIcon /> {t('form.anonymousName')}</AnCnt>
                                            )
                                            :
                                            (
                                                <>
                                                <img    
                                                    src={`${user.imagePath}`}
                                                    alt="profile"
                                                    style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }}
                                                    />
                                                {user.fullName}
                                                </>
                                            )
                                        } 
                                    </UserInfo> 
                                    <ABtn onClick={() => setAnonymous(!anonymous)} >
                                        {
                                            anonymous ?
                                            (
                                                <>
                                                    <CgProfile />
                                                    <span>{t('campaigns.donation.showProfile')}</span>
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    <MdVisibilityOff />
                                                    <span>{t('form.anonymousName')}</span>
                                                </>
                                            )
                                        }
                                    </ABtn>  
                                </div> 
                            )
                        }                            
                        <AmountInputContainer>
                        {   
                            useCustomAmount ?
                            ( 
                                <InputWrap>
                                    <label>{t('form.amount')}</label>
                                    <InputIconWrap>
                                        <input 
                                            type="number" 
                                            placeholder={t('form.amount')}
                                            value={amount}
                                            onChange={(e) => dispatch(setFormData({
                                                key: 'amount',
                                                value: e.target.value
                                            }))}
                                            />
                                    </InputIconWrap>
                                </InputWrap> 
                            )
                            :
                            (
                                <div> 
                                    <Box sx={{ width: '100%' }}> 
                                        <Slider 
                                            min={0}
                                            max={1000}
                                            step={50}
                                            defaultValue={50} 
                                            aria-label={t('accessibility.amount')}
                                            valueLabelDisplay="auto" 
                                            value={donationAmount}
                                            onChange={handleDonationAmount}
                                            />
                                    </Box>
                                    <YAD>
                                        {t('campaigns.donation.donating', { amount: formatCurrency(amount) })}
                                        <CA  onClick={() => setUseCustomAmount(!useCustomAmount)}  >
                                            {t('form.customAmount')}
                                        </CA>
                                    </YAD> 
                                </div>
                            )  
                        } 
                        {
                            // errorField.amount &&
                            true && 
                            (
                                <ErrorField> <PiArrowBendDownLeft size={35} color={'red'}/>  </ErrorField>
                            )
                        } 
                        </AmountInputContainer> 
                       
                        <ConfirmButton
                            disabled={createPaymentIntentLoading}
                            onClick={handleConfirmAmount}
                            >
                            {
                                createPaymentIntentLoading ?
                                (
                                    <SpinnerSmall />
                                )
                                :
                                (
                                    <>
                                        <RiSecurePaymentFill />
                                        <span>{t('campaigns.donation.goToPayment')}</span>
                                    </>
                                )
                            } 
                        </ConfirmButton>  
                    </PrePaymentIntentContainer>
                )
                : !updateCampaignTotalsSuccess  &&
                (
                    <YAD>
                        <div style={{  display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start' }} >
                            <span>
                                {t('campaigns.donation.donating', { amount: formatCurrency(amount) })}
                            </span>
                            <span style={{ fontSize: '12px', color: '#ccc' }} >
                                <i style={{marginRight: '5px'}}>as</i> 
                                { 
                                    anonymous ? 
                                    (
                                        t('form.anonymousName')
                                    )
                                    : user ?
                                    (
                                        user.fullName
                                    )
                                    :
                                    (
                                        name
                                    )
                                }
                            </span>
                        </div>
                        
                        <CA  onClick={handleRestartDonation}>
                            {t('campaigns.restartDonation')}
                        </CA>
                    </YAD>                 
                )
            } 

            { 
                (stripePromise && clientSecret) &&
                (
                    <Elements stripe={stripePromise} options={{clientSecret}} > 
                        <ConfirmGivingPayment />
                    </Elements>
                )
            } 

            {
                updateCampaignTotalsSuccess &&
                (
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        width: '100%',
                        height: '100%', 
                        marginTop: '-30px'
                    }} >
                        <h3 style={{ color: '#ccc', marginTop: '20px' }} > 
                            {t('campaigns.contributionSent')}
                         </h3>
                        <TbHeartCheck style={{ fontSize: '70px', color: '#ccc' }} />
                        <ConfirmButton
                            onClick={reset2}
                            >
                            {t('campaigns.restartDonation')}
                        </ConfirmButton>
                    </div>
                )
            }

        </DonateContainer>
    )
}

const PrePaymentIntentContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
`

const AnCnt = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: var(--lightThemeFontColor);

`

const UserInfo = styled.div`
    display: flex;
    width: fit-content;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 13px;
    color: var(--lightThemeFontColor);
    font-weight: 700;

    svg{
        font-size: 40px;
        margin-right: 10px;
    }

`

const AmountInputContainer = styled.div`
    position: relative;
    width: 100%;
    margin-top: 30px;
`

const ErrorField = styled.div`
    position: absolute;
    top: -5px;
    right: -60px;
    z-index: 999;
`

const ABtnW = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`
const ABtn = styled.div`
    width: 150px;
    display: flex;
    align-items: center; 
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: #626b70;
    background-color: #f2f6f8;
    border: 1px solid #e1e7eb;
    padding: 10px;
    border-radius: 7px;
    cursor: pointer;
    transition: 0.25s;
    &:hover{
        background-color: #eef1f3;
        color: #168236;
    }

    svg{
        font-size: 15px;
        margin-right: 10px;
    
    }

`

const InputIconWrap2 = styled.div`

    width: 100%;
    transition: all 0.25s ease-in-out;
    border: ${props => props.isError ? '1px solid #b73525' : '1px solid #dfe7ec'};
    border-radius: 8px;
    background-color: #fbfcfd;

    input{
        width: 100%;
        padding: 15px;
        background-color: #fbfcfd;
        border: 1px solid transparent;
        border-radius: 8px;
        outline: none;
        color: var(--lightThemeFontColor);
    }

    &:focus-within{
        border-color: #21ad46;
        box-shadow: 0 0 0 3px rgba(33, 173, 70, 0.12);
    }

`

const ConfirmButton = styled(pBtn)`
    position: absolute;
    bottom: 20px;
    width: fit-content; 
    right: 20px; 
    font-size: 16px;
    color: ${props => props.disabled ? 'white' : '#168236'};
    background-color: ${props => props.disabled ? '#21ad46' : '#eef9f1'};
    border: 1px solid ${props => props.disabled ? '#21ad46' : '#cdebd5'};
    border-radius: 7px;
    font-weight: 700;
    margin-top: 40px;
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};
    
    svg{
        font-size: 20px;
        margin-right: 10px;
    }

    &:hover{
        color: white;
        background-color: #21ad46;
        transform: translateY(-1px);
        
    } 

`

const InputWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 20px;
    label{
        font-size: 12px;
    }
    position: relative;

`

const CA = styled.div` 
    margin-left: 10px;
    padding: 5px;
    font-size: 12px;
    font-weight: 500;
    color: #168236;
    text-decoration: underline;
    cursor: pointer; 
    &:hover{
        color: #21ad46;
    }

`

const YAD = styled.div` 
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;
    color: var(--lightThemeFontColor);
    gap: 14px;
`
